export const ADMIN_PAGE_GUIDES = {
    dashboard: {
        title: "How to use the admin dashboard",
        steps: [
            "Search for a user by 8-digit mobile number or pick a name from the suggestions.",
            "Profile tab — update the customer's name and email, then click Save.",
            "Account tab — turn Verdibank, coupons, and information toggles on or off for the user. View points and activity stats.",
            "Assign tab — select coupon templates and campaigns, then create coupons for this user.",
        ],
    },
    list: {
        title: "How to read coupon reports",
        steps: [
            "Use the chips at the top to see totals for users, valid, used, expired coupons, and campaigns.",
            "Search by mobile number, name, or campaign to filter the table.",
            "Click a row to expand and see coupon details, images, and dates.",
            "Use Refresh to reload data and Clear Search to reset the filter.",
        ],
    },
    campaign: {
        title: "How to set up a campaign",
        steps: [
            "Fill in campaign details and choose how long it stays active.",
            "Select at least one coupon — these are issued to users who join.",
            "Click Create Campaign, then use QR in the table below to share the signup link.",
            "To change an existing campaign, click Edit in the table.",
        ],
    },
    createCoupon: {
        title: "How to create a coupon template",
        steps: [
            "Enter a name and optional description.",
            "Upload a coupon image (required for new templates) — shown to users in the app. When editing, leave images unchanged to keep current files.",
            "Click Create Coupon. Use these templates when building campaigns.",
            "To change a template, click Edit in the table below.",
        ],
    },
    used: {
        title: "How to view used coupons",
        steps: [
            "See how many users have redeemed coupons and which campaigns they came from.",
            "Search by mobile number, name, or campaign to narrow the list.",
            "Expand a row to view coupon images, redemption dates, and campaign details.",
            "Use Refresh to reload the latest data.",
        ],
    },
    delete: {
        title: "How to view deleted records",
        steps: [
            "This page lists user accounts that have been deleted from the system.",
            "Use the summary chips to see deleted accounts, campaigns, and coupons at a glance.",
            "Search by mobile number, name, or campaign to find a specific record.",
            "Expand a row to review what was associated with the deleted account.",
        ],
    },
};
